import { baseApi } from "api/BaseApi";

import { OrgStub } from "./orgs.types";

const ORGS_BASE_QUERY = "/org/organization";

export const orgsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLabVendors: builder.query<OrgStub[], void>({
      query: () => `${ORGS_BASE_QUERY}/my_vendors/`,
    }),
  }),
});

export const { useGetLabVendorsQuery } = orgsApi;
